module.exports = __webpack_public_path__ + "static/media/8OLA16.2302678f.jpg";